module.exports = __webpack_public_path__ + "assets/img/20211013.ac48e36e.png";